// import 'core-js/es/map';
// import 'core-js/es/set';
// import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { Provider } from 'react-redux';
import store from './form-store/index';
import * as serviceWorker from './serviceWorker';
import Recaptcha from './component/recaptcha';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable'
import Footer from './component/footer';

ReactDOM.render(
  <Provider store={store}>
    <Recaptcha>
      <App />
    </Recaptcha>
    <Footer />
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
